import React from 'react';

import { MarketingFAQ } from 'client/components/MarketingPagesShared/MarketingFAQ';
import { useT } from 'client/i18n/hooks/useT';

export function FAQ() {
  const t = useT();

  // TODO https://anchorfm.atlassian.net/browse/CAST-2750: Update FAQ List when final copy is ready
  const FAQList = [
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.SharingQuestion',
        'Can I share the same content I share on other platforms?',
        'Integration Connection Screen, FAQ section sharing question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.SharingAnswer',
        'Yes! Upload the same file to Anchor and unlock new audiences on Spotify in just a few clicks.',
        'Integration Connection Screen, FAQ section sharing answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.PromotionQuestion',
        'How can I help spread the word?',
        'Integration Connection Screen, FAQ section promotion of podcast question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.PromotionAnswer',
        'PROMOTION ANSWER',
        'Integration Connection Screen, FAQ section promotion of podcast answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.FormatQuestion',
        'What formats are accepted?',
        'Integration Connection Screen, FAQ section format question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.FormatAnswer',
        'FORMAT ANSWER',
        'Integration Connection Screen, FAQ section format answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.AvailabilityQuestion',
        'Where will my videos be available?',
        'Integration Connection Screen, FAQ section availability question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.AvailabilityAnswer',
        'AVAILABILITY ANSWER',
        'Integration Connection Screen, FAQ section availability answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.LiveStreamQuestion',
        'Can I stream live?',
        'Integration Connection Screen, FAQ section live stream question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.LiveStreamAnswer',
        'LIVE STREAM ANSWER',
        'Integration Connection Screen, FAQ section live stream answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.WhyVideoQuestion',
        'Why is Spotify adding video?',
        'Integration Connection Screen, FAQ section "why video" question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.WhyVideoAnswer',
        'WHY VIDEO ANSWER',
        'Integration Connection Screen, FAQ section "why video" answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.AddVideoQuestion',
        'Can I add video to my existing audio episodes in Anchor?',
        'Integration Connection Screen, FAQ section adding video to existing podcast question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.AddVideoAnswer',
        'ADD VIDEO ANSWER',
        'Integration Connection Screen, FAQ section adding video to existing podcast answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.MonetizeQuestion',
        'Can we monetize?',
        'Integration Connection Screen, FAQ section monetize question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.MonetizeAnswer',
        'MONETIZE ANSWER',
        'Integration Connection Screen, FAQ section monetize answer'
      ),
    },
  ];

  return <MarketingFAQ FAQList={FAQList} />;
}
